var _ellipse, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurantGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3,
    cy: 4.52344,
    rx: 3,
    ry: 3.5,
    fill: "#BABABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06431 7.90841C4.05404 7.41669 3.65248 7.02344 3.16065 7.02344C2.66884 7.02344 2.26729 7.41666 2.25699 7.90836L2.0188 19.2776C2.01413 19.5006 2.07465 19.7337 2.26048 19.8571C2.41876 19.9622 2.60871 20.0234 2.81295 20.0234H3.50804C3.71203 20.0234 3.90174 19.9624 4.05991 19.8575C4.24594 19.7342 4.30657 19.5009 4.30191 19.2777L4.06431 7.90841Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4719 1.68779C12.4543 1.31027 12.1365 1.01702 11.7588 1.02979C11.3811 1.04255 11.0838 1.35658 11.0918 1.73441L11.4532 18.9439C11.464 19.4574 11.6852 20.0431 12.1985 20.0258L12.6023 20.0121C13.1154 19.9948 13.2966 19.3959 13.2727 18.8831L12.4719 1.68779Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98803 1.72897C9.99258 1.35108 9.6925 1.03975 9.3147 1.03038C8.9369 1.02102 8.62177 1.31709 8.60757 1.69473L7.96103 18.8961C7.94173 19.4093 8.12827 20.0068 8.6417 20.0195L9.04562 20.0295C9.55887 20.0423 9.77479 19.455 9.78096 18.9416L9.98803 1.72897Z",
    fill: "#BABABA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantGray);
export default __webpack_public_path__ + "static/media/restaurant_gray.b56ad026cc2ec20134487473115b8bff.svg";
export { ForwardRef as ReactComponent };